const item = ({
  cmd = 'InsertMenu',
  param,
  icon,
  label,
  activeKey = '',
  disabledKey = '',
  className = '',
}) => {
  const hasParam = param !== undefined && param !== null && param !== '';

  return `
    <a class="fr-command teo-insert-item ${className}"
       data-cmd="${cmd}"
       ${hasParam ? `data-param1="${param}"` : ''}
       data-active-key="${activeKey}"
       data-disabled-key="${disabledKey}"
       role="option"
       tabindex="-1">
      ${icon}
      <p>${label}</p>
      <i class="fal fa-check ml-auto text-[17px] teo-active-check hidden"></i>
    </a>
  `;
};

const category = ({ className, icon, label, items }) => `
  <div class="teo-insert-category ${className}">
    <div class="teo-insert-link">
      ${icon}
      <span>${label}</span>
      <i class="far fa-chevron-right text-grey-03"></i>
    </div>
    <div class="teo-insert-submenu">
        <div class="teo-insert-submenu-scroll">
        ${items.join('')}
        </div>
    </div>
  </div>
`;

const nestedItem = ({ icon, label, items }) => `
  <div class="teo-insert-item_trigger">
    <div class="teo-insert-item">
      ${icon}
      <span>${label}</span>
      <i class="far fa-chevron-right text-grey-03 ml-auto"></i>

      <div class="teo-insert-item_sub">
        <div class="teo-insert-submenu-scroll">
            ${items.join('')}
        </div>
      </div>
    </div>
  </div>
`;

export const getInsertMenuHtml = ({ phetAssets = [] } = {}) => {
  const t = window.i18n.t;

  const contentItems = [
    item({
      cmd: 'insertLink',
      icon: '<i class="fas fa-link text-[17px]"></i>',
      label: t('widgets.toolbar_button.link'),
    }),
    item({
      cmd: 'contentLink',
      icon: '<i class="far fa-external-link text-[17px]"></i>',
      label: t('widgets.toolbar_button.content_link'),
    }),
    item({
      cmd: 'insertImage',
      icon: '<i class="fas fa-image text-[17px]"></i>',
      label: t('widgets.toolbar_button.image'),
    }),
    item({
      cmd: 'insertVideo',
      icon: '<i class="fas fa-video text-[17px]"></i>',
      label: t('widgets.toolbar_button.video'),
    }),
    item({
      param: 'ImageShowParts',
      icon: '<img src="/images/icons/AnnotatedImage-outline.svg" class="!w-5" />',
      label: t('widgets.toolbar_button.name_the_parts'),
    }),
    item({
      param: 'TabbedContentBoxes',
      icon: '<i class="far fa-layer-plus text-[17px]"></i>',
      label: t('widgets.toolbar_button.interactive_tabs'),
    }),
    item({
      cmd: '3D',
      icon: '<i class="far fa-cube text-[17px]"></i>',
      label: t('widgets.toolbar_button.3d_model'),
    }),
    item({
      cmd: 'insertTable',
      icon: '<i class="fal fa-table text-[17px]"></i>',
      label: t('widgets.toolbar_button.table'),
    }),
    nestedItem({
      icon: '<i class="far fa-omega text-[17px]"></i>',
      label: t('widgets.toolbar_button.symbols'),
      items: [
        item({
          cmd: 'emoticons',
          icon: '<i class="fas fa-grin text-[17px]"></i>',
          label: t('widgets.toolbar_button.emoji'),
        }),
        item({
          cmd: 'specialCharacters',
          icon: '<i class="far fa-omega text-[17px]"></i>',
          label: t('widgets.toolbar_button.special_character'),
        }),
      ],
    }),
    nestedItem({
      icon: '<i class="far fa-function text-[17px]"></i>',
      label: t('widgets.toolbar_button.formula'),
      items: [
        item({
          cmd: 'InlineMath',
          icon: '',
          label: t('widgets.toolbar_button.inline_formula'),
        }),
        item({
          cmd: 'Math',
          icon: '',
          label: t('widgets.toolbar_button.block_formula'),
        }),
      ],
    }),
    nestedItem({
      icon: '<i class="fas fa-lightbulb text-[17px]"></i>',
      label: t('widgets.toolbar_button.phet'),
      items: phetAssets.length
        ? phetAssets.map((el) =>
            item({
              cmd: 'Phet',
              param: String(el.id),
              icon: '<i class="fas fa-bolt text-[17px]"></i>',
              label: el.assetTitle,
            })
          )
        : [
            `<div class="teo-insert-item">
          <i class="far fa-spinner text-[17px]"></i>
          <span>Loading...</span>
        </div>`,
          ],
    }),
    item({
      cmd: 'insertFile',
      icon: '<i class="fas fa-file-minus text-[17px]"></i>',
      label: t('widgets.toolbar_button.document'),
    }),
    item({
      cmd: 'iframelyButton',
      icon: '<i class="fas fa-code text-[17px]"></i>',
      label: t('widgets.toolbar_button.embed_URL'),
    }),
    item({
      cmd: 'insertHR',
      icon: '<i class="fas fa-horizontal-rule text-[17px]"></i>',
      label: t('widgets.toolbar_button.horizontal_line'),
    }),
    item({
      cmd: 'pagebreak',
      icon: '<i class="far fa-page-break text-[17px]"></i>',
      label: t('widgets.toolbar_button.page_break'),
    }),
  ];

  const questionItems = [
    item({
      param: 'MeerKeuze',
      icon: '<i class="far fa-check-square text-[17px]"></i>',
      label: t('widgets.toolbar_button.multiple_choice'),
    }),
    item({
      param: 'OpenVraag',
      icon: '<i class="fa fa-question-circle text-[17px]"></i>',
      label: t('widgets.toolbar_button.open_question'),
    }),
    item({
      param: 'OrderVraag',
      icon: '<i class="fas fa-sort text-[17px]"></i>',
      label: t('widgets.toolbar_button.sorting_question'),
    }),
    item({
      param: 'Link',
      icon: '<i class="fas fa-bezier-curve text-[17px]"></i>',
      label: t('widgets.toolbar_button.connect_question'),
    }),
    item({
      param: 'MatrixVraag2',
      icon: '<i class="far fa-clipboard-list text-[17px]"></i>',
      label: t('widgets.toolbar_button.matrix_question'),
    }),
    item({
      param: 'NameImage2',
      icon: '<i class="far fa-tags text-[17px]"></i>',
      label: t('widgets.toolbar_button.name_parts_question'),
    }),
    item({
      param: 'InvulVraag',
      icon: '<i class="far fa-file-invoice text-[17px]"></i>',
      label: t('widgets.toolbar_button.fill_n_question'),
    }),
    item({
      param: 'FileUpload',
      icon: '<i class="fas fa-cloud-upload text-[17px]"></i>',
      label: t('widgets.toolbar_button.upload_question'),
    }),
    item({
      param: 'ShowOnPicture',
      icon: '<img src="/images/icons/show-on-picture.svg" class="!w-5" />',
      label: t('widgets.toolbar_button.show_on_picture'),
    }),
    item({
      param: 'SortGroups',
      icon: '<img src="/images/icons/sort-group.svg" class="!w-5" />',
      label: t('widgets.toolbar_button.sorting_groups'),
    }),
    item({
      param: 'KofferVraag',
      icon: '<i class="fa fa-suitcase text-[17px]"></i>',
      label: t('widgets.toolbar_button.box_question'),
    }),
    item({
      param: 'KofferVraag2',
      icon: '<i class="fa fa-suitcase text-[17px]"></i>',
      label: t('widgets.toolbar_button.box_question'),
    }),
    item({
      param: 'BoxError',
      icon: '<i class="fa fa-bug text-[17px]"></i>',
      label: t('widgets.type.box_error'),
    }),
  ];

  return `
    <div class="teo-insert-menu">
      <div class="teo-insert-row">
        <div class="teo-insert-left">
          ${category({
            className: 'teo-content-trigger',
            icon: '<i class="far fa-image text-[17px]"></i>',
            label: t('widgets.toolbar_button.content'),
            items: contentItems,
          })}

          ${category({
            className: 'teo-question-trigger',
            icon: '<i class="far fa-question-circle text-[17px]"></i>',
            label: t('widgets.toolbar_button.question'),
            items: questionItems,
          })}
        </div>
      </div>
    </div>
  `;
};

export const getParagrapStylHtml = () => {
  const t = window.i18n.t;
  const paragraphStyle = [
    item({
      cmd: 'paragraphStyle',
      param: 'fr-text-gray',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.gray'),
      activeKey: 'paragraphStyle:fr-text-gray',
      className: '!text-grey-05',
    }),
    item({
      cmd: 'paragraphStyle',
      param: 'fr-text-bordered',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.bordered'),
      activeKey: 'paragraphStyle:fr-text-bordered',
    }),
    item({
      cmd: 'paragraphStyle',
      param: 'fr-text-spaced',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.spaced'),
      activeKey: 'paragraphStyle:fr-text-spaced',
    }),
    item({
      cmd: 'paragraphStyle',
      param: 'fr-text-uppercase',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.UPPERCASE'),
      activeKey: 'paragraphStyle:fr-text-uppercase',
    }),
  ];
  const lineHeight = [
    item({
      cmd: 'lineHeight',
      param: '1',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.single'),
      activeKey: 'lineHeight:1',
    }),
    item({
      cmd: 'lineHeight',
      param: '1.15',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.1_15'),
      activeKey: 'lineHeight:1.15',
    }),
    item({
      cmd: 'lineHeight',
      param: '1.5',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.1_5'),
      activeKey: 'lineHeight:1.5',
    }),
    item({
      cmd: 'lineHeight',
      param: '2',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.double'),
      activeKey: 'lineHeight:2',
    }),
  ];
  const indentation = [
    item({
      cmd: 'outdent',
      icon: '<i class="fas fa-outdent text-[17px]"></i>',
      label: t('widgets.toolbar_button.paragrap.decrease_ind'),
      disabledKey: 'outdent',
    }),
    item({
      cmd: 'indent',
      icon: '<i class="fas fa-indent text-[17px]"></i>',
      label: t('widgets.toolbar_button.paragrap.increase_ind'),
    }),
  ];
  const quoteStyling = [
    item({
      cmd: 'quote',
      param: 'increase',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.increase'),
    }),
    item({
      cmd: 'quote',
      param: 'decrease',
      icon: '',
      label: t('widgets.toolbar_button.paragrap.decrease'),
    }),
  ];
  return `
    <div class="teo-insert-menu">
      <div class="teo-insert-row">
        <div class="teo-insert-left">
          ${category({
            className: 'teo-content-trigger',
            icon: '<i class="far fa-paragraph-rtl text-[17px]"></i>',
            label: t('widgets.toolbar_button.paragrap.paragraph_style'),
            items: paragraphStyle,
          })}

          ${category({
            className: 'teo-content-trigger',
            icon: '<i class="fas fa-line-height text-[17px]"></i>',
            label: t('widgets.toolbar_button.paragrap.line_height'),
            items: lineHeight,
          })}
     ${category({
       className: 'teo-content-trigger',
       icon: '<i class="fas fa-indent text-[17px]"></i>',
       label: t('widgets.toolbar_button.paragrap.indentation'),
       items: indentation,
     })}
     ${category({
       className: 'teo-content-trigger',
       icon: '<i class="fas fa-quote-right text-[17px]"></i>',
       label: t('widgets.toolbar_button.paragrap.quote_styling'),
       items: quoteStyling,
     })}
        </div>
      </div>
    </div>
  `;
};

export const getParagraphFormatMenuHtml = () => {
  const t = window.i18n.t;

  return `
    <div class="teo-format-menu">
      ${item({
        cmd: 'paragraphFormat',
        param: 'N',
        icon: '',
        label: window.i18n.t('widgets.toolbar_button.body_text'),
        activeKey: 'paragraphFormat:N',
      })}
      ${item({
        cmd: 'paragraphFormat',
        param: 'H1',
        icon: '',
        label: 'Heading 1',
        activeKey: 'paragraphFormat:H1',
      })}
      ${item({
        cmd: 'paragraphFormat',
        param: 'H2',
        icon: '',
        label: 'Heading 2',
        activeKey: 'paragraphFormat:H2',
      })}
      ${item({
        cmd: 'paragraphFormat',
        param: 'H3',
        icon: '',
        label: 'Heading 3',
        activeKey: 'paragraphFormat:H3',
      })}
      ${item({
        cmd: 'paragraphFormat',
        param: 'H4',
        icon: '',
        label: 'Heading 4',
        activeKey: 'paragraphFormat:H4',
      })}
      ${item({
        cmd: 'paragraphFormat',
        param: 'PRE',
        icon: '',
        label: 'Code',
        activeKey: 'paragraphFormat:PRE',
      })}
    </div>
  `;
};

export const getStrikeFormatMenuHtml = () => {
  const t = window.i18n.t;

  return `
    <div class="teo-format-menu">
      ${item({
        cmd: 'strikeThrough',
        icon: '<i class="far fa-strikethrough text-[17px]"></i>',
        label: t('widgets.toolbar_button.strikethrough'),
        activeKey: 'inlineFormat:strikeThrough',
      })}
    ${item({
      cmd: 'superscript',
      icon: '<img src="/images/icons/Superscript.svg" class="!w-5" />',
      label: t('widgets.toolbar_button.superscript'),
      activeKey: 'inlineFormat:superscript',
    })}
      ${item({
        cmd: 'subscript',
        icon: '<img src="/images/icons/Subscript.svg" class="!w-5" />',
        label: t('widgets.toolbar_button.subscript'),
        activeKey: 'inlineFormat:subscript',
      })}
      ${item({
        cmd: 'clearFormatting',
        icon: '<img src="/images/icons/removeFormat.svg" class="!w-5" />',
        label: t('widgets.toolbar_button.remove_formatting'),
      })}
    </div>
  `;
};

export const getAlignMenuHtml = () => {
  const t = window.i18n.t;
  return `
    <div class="teo-format-menu">
      ${item({
        cmd: 'alignLeft',
        icon: '<i class="far fa-align-left text-[17px]"></i>',
        label: t('widgets.toolbar_button.left_align'),
        activeKey: 'align:left',
      })}
     ${item({
       cmd: 'alignRight',
       icon: '<i class="far fa-align-right text-[17px]"></i>',
       label: t('widgets.toolbar_button.right_align'),
       activeKey: 'align:right',
     })}
      ${item({
        cmd: 'alignCenter',
        icon: '<i class="far fa-align-center text-[17px]"></i>',
        label: t('widgets.toolbar_button.middle_align'),
        activeKey: 'align:center',
      })}
      ${item({
        cmd: 'alignJustify',
        icon: '<i class="far fa-align-justify text-[17px]"></i>',
        label: t('widgets.toolbar_button.justify'),
        activeKey: 'align:justify',
      })}
    </div>
  `;
};

export const getListMenuHtml = () => {
  const t = window.i18n.t;
  return `
  <div class="teo-insert-menu teo-list-menu">
    <div class="teo-insert-row">
      <div class="teo-insert-left teo-insert-left_left">

        ${nestedItem({
          icon: '<i class="far fa-list-ol text-[17px]"></i>',
          label: t('widgets.toolbar_button.list.numbered_list'),
          items: [
            item({
              cmd: 'formatOL',
              param: 'default',
              icon: '',
              label: `${t(
                'widgets.toolbar_button.list.standard'
              )} <span class="text-grey-04">(1,2,3)</span>`,
              activeKey: 'list:OL:default',
            }),
            item({
              cmd: 'formatOL',
              param: 'lower-alpha',
              icon: '',
              label: `${t(
                'widgets.toolbar_button.list.small_letters'
              )} <span class="text-grey-04">(a,b,c)</span>`,
              activeKey: 'list:OL:lower-alpha',
            }),
            item({
              cmd: 'formatOL',
              param: 'upper-alpha',
              icon: '',
              label: `${t(
                'widgets.toolbar_button.list.large_letters'
              )} <span class="text-grey-04">(A,B,C)</span>`,
              activeKey: 'list:OL:upper-alpha',
            }),
            item({
              cmd: 'formatOL',
              param: 'lower-roman',
              icon: '',
              label: `${t(
                'widgets.toolbar_button.list.small_roman'
              )} <span class="text-grey-04">(i,ii,iii)</span>`,
              activeKey: 'list:OL:lower-roman',
            }),
            item({
              cmd: 'formatOL',
              param: 'upper-roman',
              icon: '',
              label: `${t(
                'widgets.toolbar_button.list.large_roman'
              )} <span class="text-grey-04">(I,II,III)</span>`,
              activeKey: 'list:OL:upper-roman',
            }),
            item({
              cmd: 'formatOL',
              param: 'lower-greek',
              icon: '',
              label: `${t(
                'widgets.toolbar_button.list.small_greek'
              )} <span class="text-grey-04">(α,β,γ)</span>`,
              activeKey: 'list:OL:lower-greek',
            }),
          ],
        })}

        ${nestedItem({
          icon: '<i class="far fa-list-ul text-[17px]"></i>',
          label: t('widgets.toolbar_button.list.bullet_list'),
          items: [
            // item({
            //     cmd: 'formatUL',
            //     param: 'dash',
            //     icon: '<i class="fas fa-horizontal-rule text-[12px]"></i>',
            //     label: t('widgets.toolbar_button.list.dash'),
            //     activeKey: 'list:UL:dash',
            // }),
            item({
              cmd: 'formatUL',
              param: 'disc',
              icon: '<i class="fas fa-circle text-[17px]"></i>',
              label: t('widgets.toolbar_button.list.dot'),
              activeKey: 'list:UL:disc',
            }),
            item({
              cmd: 'formatUL',
              param: 'circle',
              icon: '<i class="far fa-circle text-[17px]"></i>',
              label: t('widgets.toolbar_button.list.circle'),
              activeKey: 'list:UL:circle',
            }),
            item({
              cmd: 'formatUL',
              param: 'square',
              icon: '<i class="fas fa-square text-[17px]"></i>',
              label: t('widgets.toolbar_button.list.square'),
              activeKey: 'list:UL:square',
            }),
          ],
        })}

      </div>
    </div>
  </div>
`;
};

export const getMoreMenuHtml = () => {
  const t = window.i18n.t;
  return `
    <div class="teo-format-menu">
      ${item({
        cmd: 'selectAll',
        icon: '<img src="/images/icons/selectAll.svg" class="!w-5" />',
        label: t('widgets.toolbar_button.select_all'),
      })}
      ${item({
        cmd: 'html',
        icon: '<img src="/images/icons/code.svg" class="!w-5" />',
        label: t('widgets.toolbar_button.code_view'),
        activeKey: 'codeView:html',
      })}
      ${item({
        cmd: 'help',
        icon: '<i class="far fa-question-circle text-[17px]"></i>',
        label: t('widgets.toolbar_button.help'),
      })}
    </div>
  `;
};
